const DEFAULT_API_HOST = "https://us.i.posthog.com";

function getRouteTemplate(route) {
  const matchedRoute = Array.isArray(route.matched)
    ? [...route.matched].reverse().find((item) => item?.path)
    : null;
  return matchedRoute?.path || route.path || "/";
}

function getSanitizedCurrentUrl(currentUrl, routePath) {
  try {
    return `${new URL(currentUrl).origin}${routePath}`;
  } catch {
    return routePath;
  }
}

export function initializePostHog({
  client,
  router,
  apiKey,
  apiHost,
  getCurrentUrl = () => window.location.href,
}) {
  const normalizedApiKey = String(apiKey || "").trim();
  if (!normalizedApiKey) {
    return false;
  }

  const normalizedApiHost = String(apiHost || DEFAULT_API_HOST)
    .trim()
    .replace(/\/+$/, "");

  client.init(normalizedApiKey, {
    api_host: normalizedApiHost,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: "identified_only",
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      blockSelector:
        "input[type='file'], input[type='hidden'], img, video, canvas, .ph-no-capture",
    },
  });

  router.afterEach((to) => {
    const routePath = getRouteTemplate(to);
    client.capture("$pageview", {
      $current_url: getSanitizedCurrentUrl(getCurrentUrl(), routePath),
      route_name: to.name ? String(to.name) : null,
      route_path: routePath,
    });
  });

  return true;
}

export async function setupPostHog(router, options = {}) {
  const apiKey = options.apiKey ?? process.env.VUE_APP_POSTHOG_KEY;
  if (!String(apiKey || "").trim()) {
    return false;
  }

  const loadClient =
    options.loadClient ??
    (async () => {
      const module = await import("posthog-js");
      return module.default;
    });
  const client = await loadClient();

  return initializePostHog({
    client,
    router,
    apiKey,
    apiHost: options.apiHost ?? process.env.VUE_APP_POSTHOG_HOST,
  });
}
